// validationSchema.js
import * as yup from "yup";

export const profileSchema = yup.object().shape({
  // fullName: yup.string().required("Name is required"),
  // email: yup.string().required("Email is required"),
});
